import React, { Component } from "react";
import axios from "axios";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import "../../style-sheets/home.css";
import TestList from "./TestList";
import "antd/dist/antd.css";
import { DatePicker, Checkbox, Select, TimePicker, Spin } from "antd";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
// import { Link } from "react-router-dom";
import ViewMap from "../ViewMap";
import isEqual from "lodash/isEqual";
import Geocode from "react-geocode";
import moment from "moment";
import { APILINK } from "../../Endpoint";

//redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  agentRequestData,
  searchResultSuppliers,
  clearRes,
  agentCoRequest,
} from "../../global-state/actions/agentRequestAction";

import { changeOrderType } from "../../global-state/actions/changeTypeAction";
import { ReloadContext } from "../../hooks/ReloadContext";

const axiosApiInstance = axios.create();
Geocode.setApiKey("AIzaSyDGLV2zbFZNvPOeFtuePcisgwAbmVIsSH0");

class AgentHome extends Component {
  static contextType = ReloadContext;

  constructor(props) {
    super(props);
    this.state = {
      keywords: [],
      category: [],
      selectedKeys: [],
      selectedCat: [],
      keysID: [],
      keysNames: [],
      catNames: [],
      catID: [],
      lat: "",
      lng: "",
      selectedDate: "",
      whichModal: 0,
      show: false,
      allVehicles: [],
      allServices: [],
      approval_need: "",
      provide_wallet: "",
      price: "",
      selectedData: "",
      selectedVehiclesId: [],
      selectedServicesId: [],
      selectedFile: null,
      location: {},
      FEError: "",
      showSpinner: false,
      showSpinner2: false,
      code: "",
      validated: false,
      errorHandel: "",
      showWarning: false,
      selectedTime: "",
      selectedYanzoCat: "",
      emirates: [],
      pickupEmirate: undefined,
      pickupAreas: [],
      selectedPickupArea: undefined,
      dropOffEmirate: undefined,
      dropOffAreas: [],
      selectedDropOffArea: undefined,
      yanzoCat: [
        { id: 1, name: "Pickup" },
        { id: 2, name: "Food" },
        { id: 3, name: "Retail" },
        { id: 4, name: "Bookings" },
        { id: 5, name: "Services" },
      ],
      types: [],
      note: "",
    };
  }

  handleSubmit = (e) => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      this.onCoSearch();
    }
    this.setState({ validated: true });
    e.preventDefault();
  };
  handleKeys = (e) => {
    console.log({ cat: e });
    this.setState({
      selectedKeys: e,
    });

    let x = e.map((val) => {
      return val.value;
    });

    let y = e.map((val) => {
      return val.label;
    });
    this.setState({
      keysID: x,
      keysNames: y,
    });
  };
  handleCate = (e) => {
    console.log({ e });
    this.setState({
      selectedCat: e,
    });

    let x = e.map((val) => {
      return val.value;
    });

    let y = e.map((val) => {
      return val.label;
    });
    this.setState({
      catID: x,
      catNames: y,
    });
  };

  getCoor = (e, d) => {
    this.setState({ lat: e, lng: d });
  };

  getCategories = async () => {
    const result = await axiosApiInstance.get(
      APILINK + "/categories/?limit=10000"
    );

    // console.log(result);
    if (result) {
      this.setState({ category: result.data.results });
      let types = result.data.results.filter((a) => a.type);
      this.setState({ types: types });
    }
  };
  getKeys = async () => {
    const result = await axiosApiInstance.get(
      APILINK + `/keywords/?limit=10000`
    );
    if (result) {
      this.setState({ keywords: result.data.results });
    }
  };

  getEmirates = async () => {
    const result = await axiosApiInstance.get(APILINK + `/emirate?limit=10000`);
    if (result) {
      console.log({ result });
      this.setState({ emirates: result.data.results });
    }
  };

  async handleEmirateSelect(areaTypes, emirate) {
    console.log({ emirate, areaTypes });
    const result = await axiosApiInstance.get(
      APILINK + `/areas/${emirate}?limit=10000`
    );
    if (result) {
      console.log({ result: result.data });
      if (areaTypes === "dropOffAreas")
        this.setState({ dropOffAreas: result.data });
      else this.setState({ pickupAreas: result.data });
    }
  }

  componentDidMount() {
    this.props.clearRes();
    this.props.agentCoRequest({});
    this.getEmirates();
    console.log({ context: this.context });
    const context = this.context;

    console.log(context); // { name: 'Tania', loggedIn: true }
  }

  openModal1 = (e) => {
    this.setState({ show: true, whichModal: 1 });
  };
  openModal2 = (e) => {
    this.setState({ show: true, whichModal: 2 });
  };

  close = (e) => {
    this.setState({ show: false });
  };

  handleTime1 = (time, timeString) => {
    this.setState({ selectedTime: timeString });
  };

  handleDate1 = (date, dateString) => {
    this.setState({ scheduledDate: dateString });
  };

  onHandleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSearch = (e) => {
    this.setState({ showSpinner2: true });
    if (this.state.selectedFile !== null) {
      let data = {
        PreRequest: {
          name: this.state.name,
          product_quantity: this.state.quantity,
          client_name: "test",
          client_phone: "011458888963",
          client_address: this.state.address,
          latitude: this.state.location.lat,
          longitude: this.state.location.lon,
          expected_delivery_date: this.state.selectedTime,
          keyword: this.state.keysID,
          category: this.state.catID,
          image: this.state.selectedFile,
          ticket_code: this.state.ticket,
          yanzo_category: this.state.selectedYanzoCatName,
          notes: this.state.note,
        },
      };
      this.props.agentRequestData(data);
      this.searchForSuppliers();
    } else {
      let data = {
        PreRequest: {
          name: this.state.name,
          product_quantity: this.state.quantity,
          client_name: "test",
          client_phone: "011458888963",
          client_address: this.state.address,
          latitude: this.state.location.lat,
          longitude: this.state.location.lon,
          expected_delivery_date: this.state.selectedTime,
          keyword: this.state.keysID,
          category: this.state.catID,
          ticket_code: this.state.ticket,
          yanzo_category: this.state.selectedYanzoCatName,
          notes: this.state.note,

          // image: '',
        },
      };
      this.props.agentRequestData(data);
      this.searchForSuppliers();
    }
  };

  searchForSuppliers = async (e) => {
    if (
      this.state.name === "" ||
      this.state.quantity === "" ||
      this.state.address === "" ||
      this.state.selectedTime === "" ||
      this.state.keysID.length === 0 ||
      this.state.catID.length === 0
    ) {
      this.setState({
        FEError: "Fill out all fields first",
        showSpinner2: false,
      });
    } else {
      this.setState({ FEError: "" });
      let link;

      //to take selected values lw hya aktr mn haga f array , make them string and seperate between them with __ to send it inside request params
      let x = this.state.catID.toString();
      var res = x.replace(/,/g, "__");
      // console.log(res);

      let y = this.state.keysID.toString();
      var res2 = y.replace(/,/g, "__");
      // console.log(y);
      // console.log(res2);
      link =
        APILINK +
        `/suppliers/?${res ? `categories__in=${res}` : ""}&${
          res2 ? `keywords__in=${res2}` : ""
        }&${
          this.state.product
            ? `product_contains=${this.state.product}&ordering=price`
            : ""
        }`;

      //hna call search ll back w el res ab3tha le redux to store it and view in supplier list

      const result = await axiosApiInstance.get(`${link}`);
      if (result) {
        if (result.data) {
          this.props.searchResultSuppliers(result.data);
          this.props.history.push("/view_suppliers");
          this.setState({ showSpinner2: false });
        }
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevState.reload, this.context)) {
    }
    if (!isEqual(prevState, this.state)) {
      if (
        this.state.name !== "" &&
        this.state.quantity !== "" &&
        this.state.address !== "" &&
        (this.state.selectedDate !== "") === "" &&
        this.state.keysID.length !== 0 &&
        this.state.catID.length !== 0
      ) {
        this.setState({ FEError: "" });
      }

      if (
        this.state.selectedServicesId.length !== 0 ||
        this.state.selectedVehiclesId.length !== 0 ||
        this.state.price !== "" ||
        this.state.selectedTime !== ""
      ) {
        this.setState({ showWarning: false });
      }
    }
  }

  getVehicles = async () => {
    // console.log(newID);
    const result = await axiosApiInstance.get(
      APILINK + `/vehicle_types/?limit=10000`
    );
    if (result) {
      this.setState({ allVehicles: result.data.results });
    }
  };

  getService = async () => {
    const result = await axiosApiInstance.get(
      APILINK + `/delivery_service?limit=10000`
    );
    if (result) {
      this.setState({ allServices: result.data.data });
    }
  };

  handleTime = (time, timeString) => {
    this.setState({ selectedTime: timeString });
  };

  handleVehicles = (e) => {
    this.setState({
      selectedVehicles: e,
      selectedVehiclesId: e,
    });
    console.log(e);
  };
  handleServices = (e) => {
    this.setState({
      selectedServices: e,
      selectedServicesId: e,
    });
    console.log(e);
  };
  handleSubmitData = (e) => {
    this.setState({
      selectedData: e,
    });
  };
  handleWallet = (e) => {
    this.setState({ provide_wallet: e.target.checked });
  };
  handleApproval = (e) => {
    this.setState({ approval_need: e.target.checked });
  };

  convert_id = (id) => id.split("-").join("");

  onCoSearch = async (e) => {
    if (!this.state.selectedPickupArea || !this.state.selectedDropOffArea) {
      this.setState({ showSpinner: false, showWarning: true });
      return;
    }

    if (
      this.state.selectedServicesId.length === 0 &&
      this.state.selectedVehiclesId.length === 0 &&
      this.state.price == "" &&
      this.state.selectedTime == ""
    ) {
      this.setState({ showSpinner: false, showWarning: true });
    } else {
      this.setState({ showSpinner: true });

      let link;
      if (
        this.state.selectedVehiclesId.length === 1 &&
        this.state.selectedServicesId.length === 1
      ) {
        let x = this.state.selectedVehiclesId.toString();
        let y = this.state.selectedServicesId.toString();
        let z = y.replace(/-/g, "");
        link =
          APILINK +
          `/courier_services/?vehicle=${x}&delivery=${z}&price__lte=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      } else if (
        this.state.selectedVehiclesId.length === 1 &&
        this.state.selectedServicesId.length !== 1
      ) {
        let x = this.state.selectedServicesId.toString();
        var res = x.replace(/,/g, "__");
        let z = res.replace(/-/g, "");
        let y = this.state.selectedVehiclesId.toString();

        link =
          APILINK +
          `/courier_services/?vehicle=${y}&delivery__in=${z}&price__lte=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      } else if (
        this.state.selectedVehiclesId.length !== 1 &&
        this.state.selectedServicesId.length === 1
      ) {
        let x = this.state.selectedVehiclesId.toString();
        var res = x.replace(/,/g, "__");

        let y = this.state.selectedServicesId.toString();
        let z = y.replace(/-/g, "");

        link =
          APILINK +
          `/courier_services/?vehicle__in=${res}&delivery=${z}&price__lte=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      } else if (
        this.state.selectedVehiclesId.length === 0 ||
        this.state.selectedServicesId.length === 0
      ) {
        link =
          APILINK +
          `/courier_services/?price__lte=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      } else {
        //to take selected values lw hya aktr mn haga f array , make them string and seperate between them with __ to send it inside request params
        let x = this.state.selectedVehiclesId.toString();
        var res = x.replace(/,/g, "__");
        // console.log(res);

        let y = this.state.selectedServicesId.toString();
        var res2 = y.replace(/,/g, "__");
        let z = res2.replace(/-/g, "");

        link =
          APILINK +
          `/courier_services/?vehicle__in=${res}&delivery__in=${z}&price__lte=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      }

      let area = [this.state.selectedPickupArea, this.state.selectedDropOffArea]
        .toString()
        .replace(/-/g, "")
        .replace(/,/g, "__");

      console.log({ st: this.state.selectedPickupArea });
      console.log({ area });
      link = `${link}&pick_up_emirate=${this.convert_id(
        this.state.selectedPickUpEmirateObj.id
      )}&drop_off_emirate=${this.convert_id(
        this.state.selectedDropOffEmirateObj.id
      )}&pick_up_area=${this.convert_id(
        this.state.selectedPickupArea
      )}&drop_off_area=${this.convert_id(this.state.selectedDropOffArea)}`;
      console.log({ link });
      const result = await axiosApiInstance.get(`${link}`);

      if (result) {
        console.log(result);
        console.log(this.state.selectedDropOffEmirateObj);
        sessionStorage.setItem(
          "CoSearchData",
          JSON.stringify({
            pickupEmirate: this.state.selectedPickUpEmirateObj,
            dropOffEmirate: this.state.selectedDropOffEmirateObj,
            pickupArea: this.state.selectedPickupAreaObj,
            dropOffArea: this.state.selectedDropOffAreaObj,
            scheduledDate: this.state.scheduledDate,
            selectedTime: this.state.selectedTime,
            notes: this.state.notes,
          })
        );
        this.props.agentCoRequest(result.data);
        this.props.changeOrderType("2");
        setTimeout(() => {
          this.props.history.push(
            "/view_couriers/" + this.state.selectedDropOffArea
          );
        }, 1000);
      }
    }
  };

  onFileUpload = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = (e) => {
      console.log(e.target.result);
      this.setState({ selectedFile: e.target.result });
    };
  };

  handleAddress = (e) => {
    this.setState({ address: e.target.value });
    // Get latitude & longitude from address.
    Geocode.fromAddress(e.target.value).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        this.setState((prevState) => ({
          location: {
            lat: lat,
            lon: lng,
          },
        }));
      },
      (error) => {
        console.error(error);
      }
    );
  };
  handleYanzoCat = (e) => {
    console.log(e);
    this.setState({ selectedYanzoCat: e });
    this.setState({ selectedYanzoCatName: e.value });
  };
  onDelete = (e) => {
    // const
  };

  render() {
    return (
      <div>
        <Container
          style={{
            marginTop: "80px",
            //  marginLeft: "250px"
          }}
          className="pt-3"
        >
          <Row>
            <Col className="   d-flex align-items-center " sm={4}>
              <h2>
                {" "}
                <i class="fas fa-home pr-2"></i> Home
              </h2>
            </Col>
            <Col
              // className=" p-4 mb-4"
              // style={{ textAlign: "right" }}
              className=" p-4 mb-4 d-flex align-items-center justify-content-sm-center  justify-content-lg-end"
              sm={8}
            >
              <Button onClick={this.openModal1} className="headBtn">
                + Submit Supplier Request
              </Button>
              <Button onClick={this.openModal2} className="headBtn">
                + Submit Courier Request
              </Button>
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={12}>
              <TestList onDelete={this.onDelete} />
            </Col>
          </Row>
        </Container>
        {this.state.whichModal === 1 ? (
          <Modal show={this.state.show} onHide={this.close}>
            <Container className="p-3">
              <Row>
                <Col sm={12}>
                  <h6>Create New Order</h6>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <Form.Label>
                    {" "}
                    <strong
                      style={{
                        color: "red",
                        paddingRight: "5px",
                      }}
                    >
                      *
                    </strong>
                    Ticket Number
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Ticket Number"
                    value={this.state.ticket}
                    name="ticket"
                    onChange={this.onHandleInput}
                    required
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <Form.Label>
                    {" "}
                    <strong
                      style={{
                        color: "red",
                        paddingRight: "5px",
                      }}
                    >
                      *
                    </strong>
                    Order Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="name"
                    value={this.state.name}
                    name="name"
                    onChange={this.onHandleInput}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <Form.Label>
                    {" "}
                    <strong
                      style={{
                        color: "red",
                        paddingRight: "5px",
                      }}
                    >
                      *
                    </strong>
                    Product Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Product Name"
                    value={this.state.product}
                    name="product"
                    onChange={this.onHandleInput}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <Form.Label>
                    {" "}
                    <strong
                      style={{
                        color: "red",
                        paddingRight: "5px",
                      }}
                    >
                      *
                    </strong>
                    Order Quantity
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Quantity"
                    value={this.state.quantity}
                    name="quantity"
                    onChange={this.onHandleInput}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <Form.Label>
                    {" "}
                    <strong
                      style={{
                        color: "red",
                        paddingRight: "5px",
                      }}
                    >
                      *
                    </strong>
                    KeyWords
                  </Form.Label>
                  <Select
                    mode="multiple"
                    showSearch
                    onClick={this.getKeys}
                    placeholder="Select keywords"
                    value={this.state.selectedKeys}
                    labelInValue
                    onChange={this.handleKeys}
                    style={{ width: "100%" }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.keywords.map((item) => (
                      <Select.Option
                        key={item.id}
                        name={item.name}
                        value={item.id}
                      >
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <Form.Label>
                    {" "}
                    <strong
                      style={{
                        color: "red",
                        paddingRight: "5px",
                      }}
                    >
                      *
                    </strong>
                    Category
                  </Form.Label>

                  <Select
                    mode="multiple"
                    showSearch
                    labelInValue
                    onClick={this.getCategories}
                    placeholder="select category"
                    value={this.state.selectedCat}
                    onChange={this.handleCate}
                    style={{ width: "100%" }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.category.map((item) => (
                      <Select.Option
                        name={item.name}
                        key={item.id}
                        value={item.id}
                      >
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <Form.Label>
                    {" "}
                    <strong
                      style={{
                        color: "red",
                        paddingRight: "5px",
                      }}
                    >
                      *
                    </strong>
                    Yanzo Category
                  </Form.Label>

                  <Select
                    showSearch
                    labelInValue
                    placeholder="select yanzo category"
                    value={this.state.selectedYanzoCat}
                    onChange={this.handleYanzoCat}
                    style={{ width: "100%" }}
                    onClick={this.getCategories}
                  >
                    {this.state.types.map((item) => (
                      <Select.Option value={item.type}>
                        {item.type}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
              <Row className="mb-1">
                <Col sm={12} md={12}>
                  <Form.Label>
                    {" "}
                    <strong
                      style={{
                        color: "red",
                        paddingRight: "5px",
                      }}
                    >
                      *
                    </strong>
                    Address
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Address"
                    value={this.state.address}
                    name="address"
                    onChange={this.handleAddress}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <Form.Label>Attach Image</Form.Label>
                  <form>
                    <input
                      onChange={this.onFileUpload}
                      type="file"
                      id="myFile"
                      name="filename"
                      className="custom"
                    />
                  </form>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col className="" sm={12} md={12}>
                  <ViewMap location={this.state.location} />
                </Col>
              </Row>
              <Row className="mb-1">
                <Col sm={12} md={12}>
                  <Form.Label>
                    {" "}
                    <strong
                      style={{
                        color: "red",
                        paddingRight: "5px",
                      }}
                    >
                      *
                    </strong>
                    Delivery Time{" "}
                  </Form.Label>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <DatePicker
                    // showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD"
                    onChange={this.handleTime1}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} md={12}>
                  <Form.Label> Notes</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Notes..."
                    onChange={this.onHandleInput}
                    name="note"
                    value={this.state.note}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{ textAlign: "right" }} sm={12} md={12}>
                  {this.state.showSpinner2 ? (
                    <Spin tip="Loading..."></Spin>
                  ) : null}
                  <Button onClick={this.onSearch} className="supplierBtn">
                    Search
                  </Button>
                </Col>
                <Col style={{ textAlign: "center" }} sm={12} md={12}>
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "red",
                    }}
                  >
                    {this.state.FEError}
                  </p>
                </Col>
              </Row>
            </Container>{" "}
          </Modal>
        ) : (
          <Modal show={this.state.show} onHide={this.close}>
            <Container className="p-3">
              <Row>
                <Col sm={12}>
                  <h6>Search For Couriers</h6>
                </Col>
              </Row>
              <Form
              // noValidate
              // validated={this.state.validated}
              // onSubmit={this.handleSubmit}
              >
                <Row className="mb-3">
                  <Col sm={12} md={6}>
                    <Form.Label>Pickup Emirate</Form.Label>
                    <Select
                      required
                      showSearch
                      placeholder="select pickup emirate"
                      value={this.state.dropOffEmirate}
                      onChange={(v) => {
                        this.handleEmirateSelect(
                          "pickUpAreas",
                          this.state.emirates[v].id
                        );
                        this.setState({
                          selectedPickUpEmirateObj: this.state.emirates[v],
                        });
                      }}
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {this.state.emirates.map((item, i) => (
                        <Select.Option name={item.name} key={item.id} value={i}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Label>Pickup Area</Form.Label>
                    <Select
                      required
                      showSearch
                      placeholder="select pickup area"
                      style={{ width: "100%" }}
                      onChange={(i) =>
                        this.setState({
                          selectedPickupArea: this.state?.pickupAreas[i]?.id,
                          selectedPickupAreaObj: this.state?.pickupAreas[i],
                        })
                      }
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {this.state.pickupAreas?.map((item, i) => (
                        <Select.Option name={item.name} key={item.id} value={i}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={12} md={6}>
                    <Form.Label>Drop off Emirate</Form.Label>
                    <Select
                      required
                      showSearch
                      placeholder="select drop off emirate"
                      value={this.state.dropOffEmirate}
                      onChange={(v) => {
                        this.handleEmirateSelect(
                          "dropOffAreas",
                          this.state.emirates[v].id
                        );
                        this.setState({
                          selectedDropOffEmirateObj: this.state.emirates[v],
                        });
                      }}
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {this.state.emirates.map((item, i) => (
                        <Select.Option name={item.name} key={item.id} value={i}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Label>Drop off Area</Form.Label>
                    <Select
                      required
                      showSearch
                      placeholder="select drop off area"
                      style={{ width: "100%" }}
                      onChange={(i) =>
                        this.setState({
                          selectedDropOffArea: this.state?.dropOffAreas[i].id,
                          selectedDropOffAreaObj: this.state?.dropOffAreas[i],
                        })
                      }
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {this.state.dropOffAreas?.map((item, i) => (
                        <Select.Option name={item.name} key={item.id} value={i}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={12} md={12}>
                    <Form.Label>Vehicles</Form.Label>
                    <Select
                      mode="multiple"
                      required
                      showSearch
                      onClick={this.getVehicles}
                      placeholder="Select Vehicles"
                      value={this.state.selectedVehicles}
                      // labelInValue
                      onChange={this.handleVehicles}
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {this.state.allVehicles.map((item) => (
                        <Select.Option
                          key={item.id}
                          name={item.name}
                          value={item.id}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                    {/* {this.state.selectedVehiclesId.length == 0 &&
                    this.state.errorHandel !== "" ? (
                      <p className="errorHandel">{this.state.errorHandel}</p>
                    ) : null} */}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col sm={12} md={12}>
                    <Form.Label>Delivery Services</Form.Label>

                    <Select
                      mode="multiple"
                      required
                      showSearch
                      onClick={this.getService}
                      placeholder="select services"
                      value={this.state.selectedServices}
                      onChange={this.handleServices}
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {this.state.allServices.map((item) => (
                        <Select.Option
                          name={item.name}
                          key={item.id}
                          value={item.id}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                    {/* {this.state.selectedServicesId.length == 0 &&
                    this.state.errorHandel !== "" ? (
                      <p className="errorHandel">{this.state.errorHandel}</p>
                    ) : null} */}
                  </Col>
                </Row>

                <Row className="mb-1">
                  <Col sm={12} md={12}>
                    <Form.Label>Delivery Date</Form.Label>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={12} md={12}>
                    <DatePicker
                      onChange={this.handleDate1}
                      format="YYYY-MM-DD"
                      required
                    />
                    {/* {this.state.selectedDate == "" &&
                    this.state.errorHandel !== "" ? (
                      <p className="errorHandel">{this.state.errorHandel}</p>
                    ) : null} */}
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col sm={12} md={12}>
                    <Form.Label>Delivery Time</Form.Label>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={12} md={12}>
                    <TimePicker
                      onChange={this.handleTime1}
                      defaultOpenValue={moment("00:00:00", "HH:mm:ss")}
                      required
                    />
                    {/* {this.state.selectedDate == "" &&
                    this.state.errorHandel !== "" ? (
                      <p className="errorHandel">{this.state.errorHandel}</p>
                    ) : null} */}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={12} md={12}>
                    <Form.Group controlId="notes">
                      <Form.Label>Notes</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="notes"
                        value={this.state.notes}
                        name="notes"
                        onChange={this.onHandleInput}
                        // required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="my-2">
                  <Col sm={12} md={6}>
                    <Checkbox onChange={this.handleWallet}>
                      Provide Wallet
                    </Checkbox>
                  </Col>
                </Row>
                <Row>
                  <Col style={{ textAlign: "right" }} sm={12} md={12}>
                    {this.state.showSpinner ? (
                      <Spin tip="Loading..."></Spin>
                    ) : null}
                    <Button
                      onClick={this.onCoSearch}
                      // type="submit"
                      className="supplierBtn"
                    >
                      Search
                    </Button>
                  </Col>
                </Row>

                {this.state.showWarning ? (
                  <p className="errorHandel text-center">
                    You need to enter one field at least
                  </p>
                ) : null}
              </Form>
            </Container>{" "}
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuth,
  user: state.auth.user,
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      agentRequestData,
      searchResultSuppliers,
      clearRes,
      agentCoRequest,
      changeOrderType,
    },
    dispatch
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorHandler(AgentHome, axiosApiInstance));
